import gql from 'graphql-tag';
const BUILD_A_SENTENCE_ACTIVITY_FRAGMENT = gql `
  fragment BuildASentenceActivityFragment on BuildASentenceActivity {
    rounds {
      dropdowns {
        id
        name
        answers {
          id
          answer
          monochromeImage {
            id
            image {
              id
              src
            }
          }
          colorImage {
            id
            image {
              id
              src
            }
          }
        }
      }
    }
  }
`;
export default BUILD_A_SENTENCE_ACTIVITY_FRAGMENT;
